import { Component, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { AgreementFacade } from '@app2/features/agreement/agreement.facade';
import { AnalystService } from '@app/services/analyst/analyst.service';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';

@Component({
  selector: 'sens-agreement',
  imports: [
    NgOptimizedImage,
    RouterLink,
  ],
  templateUrl: './agreement.component.html',
  providers: [AgreementFacade],
  standalone: true,
})
export class AgreementComponent {

  readonly facade = inject(AgreementFacade);

  readonly analystService = inject(AnalystService);

  onClick(param: string): void {
    this.analystService.logEvent(AnalyticsEventsEnum.AgreementTap, {
      type: param,
    }).then();
    this.facade.onClick(param);
  }
}
